/** Origens de lançamentos e cadastros */
export interface OrigemLancamentoCadastro {
    id: number;
    nome: string;
}

export const origemLancamentoCadastroDesconhecida: OrigemLancamentoCadastro = {id: 0, nome: 'Desconhecida'};
export const origemLancamentoCadastroSogivendas: OrigemLancamentoCadastro = {id: 1, nome: 'Sogivendas'};
export const origemLancamentoCadastroErp: OrigemLancamentoCadastro = {id: 2, nome: 'ERP'};
export const origemLancamentoCadastroEcommerce: OrigemLancamentoCadastro = {id: 3, nome: 'E-commerce'};
export const origemLancamentoCadastroProspeccaoOutbound: OrigemLancamentoCadastro = {id: 4, nome: 'Prospecção Outbound'};



export const origensLancamentosCadastros: OrigemLancamentoCadastro[] = [
    origemLancamentoCadastroSogivendas,
    origemLancamentoCadastroErp,
    origemLancamentoCadastroEcommerce,
    origemLancamentoCadastroProspeccaoOutbound
];

/** Verifica se a origem do lançamento/cadastro é desconhecida */
export function isOrigemLancamentoCadastroDesconhecida(id: number): boolean {
    return id === origemLancamentoCadastroDesconhecida.id;
}

/** Verifica se a origem do lançamento/cadastro é o Sogivendas */
export function isOrigemLancamentoCadastroSogivendas(id: number): boolean {
    return id === origemLancamentoCadastroSogivendas.id;
}

/** Verifica se a origem do lançamento/cadastro é o ERP */
export function isOrigemLancamentoCadastroErp(id: number): boolean {
    return id === origemLancamentoCadastroErp.id;
}

/** Verifica se a origem do lançamento/cadastro é o E-commerce */
export function isOrigemLancamentoCadastroEcommerce(id: number): boolean {
    return id === origemLancamentoCadastroEcommerce.id;
}


/** Verifica se a origem do lançamento/cadastro é pela Prospecção Outbound */
export function isOrigemLancamentoCadastroProspeccaoOutbound(id: number): boolean {
    return id === origemLancamentoCadastroProspeccaoOutbound.id;
}
